<template>
  <div v-if="show" class="conf-overlay" @click="$emit('cancel')">
    <div class="conf-modal" @click.stop>
      <div class="conf-notice rounded p-3" style="background-color: #dee9f5;">
        <slot name="content"></slot>
      </div>

      <!-- Desktop footer -->
      <div class="swal-footer d-flex justify-content-center p-4 full">
        <button class="btn text-white btn-sm rounded mx-3 cancelBtn w-230" @click="$emit('cancel')">
          {{ cancelText }}
        </button>
        <button class="btn text-white btn-sm rounded mx-3 text-center confirmBtn w-230" @click="$emit('confirm')">
          <slot name="confirm-text"></slot>
        </button>
      </div>

      <!-- Mobile footer -->
      <div class="swal-footer d-flex justify-content-center p-4 mobile">
        <button class="btn text-white btn-sm rounded text-center confirmBtn w-230" @click="$emit('confirm')">
          <slot name="confirm-text"></slot>
        </button>
        <button class="btn text-white btn-sm rounded cancelBtn w-230" @click="$emit('cancel')">
          {{ cancelText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: 'キャンセル'
    }
  }
}
</script>

<style scoped>
.conf-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.conf-modal {
  background: #fff;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  overflow: hidden;
}

.conf-notice {
  background-color: #dee9f5 !important;
}


.cancelBtn {
  background: #666666;
  border: 1px solid #666666;
}

.cancelBtn:hover {
  background: #494949 !important;
}

.confirmBtn {
  background: #ff0000;
  border: 1px solid #ff0000;
  line-height: 1.4;
  white-space: normal;
}

.confirmBtn:hover {
  background: #c20101 !important;
}

.w-230 {
  width: 230px;
  height: 60px;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.mobile {
  display: none !important;
}

@media (max-width: 768px) {
  .full {
    display: none !important;
  }

  .mobile {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 12px;
  }

  .mobile .confirmBtn,
  .mobile .cancelBtn {
    width: 318px !important;
    height: 53px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
